import { Routes } from '@angular/router';
import { isAuthenticated } from '@rsmu/auth';
import { NavigationPageComponent } from './pages/navigation-page/navigation-page.component';
import { QuizPageComponent } from './pages/quiz-page/quiz-page.component';
import { OepPageComponent } from './pages/oep-page/oep-page.component';


export const STUDENT_CABINET_ROUTES: Routes = [
  {
    path: '',
    canActivate: [isAuthenticated],
    loadComponent: () => import('../student-cabinet/pages/main-page/main-page.component').then(m => m.MainPageComponent),
    children: [
      {
        path: '',
        component: OepPageComponent,
        children: [
          {
            path: '',
            component: NavigationPageComponent
          },
          {
            path: 'step/:stepId',
            loadComponent: () => import('../student-cabinet/pages/step-page/step-page.component').then(m => m.StepPageComponent)
          },
        ]
      },
      {
        path: 'bisz/:biszId',
        canActivate: [isAuthenticated],
        loadChildren: () => import('@rsmu/isz').then(m => m.IszModule)
      }
    ]
  },
  {
    path: 'quiz/:quizId',
    canActivate: [isAuthenticated],
    component: QuizPageComponent,
  }
];